import { Injectable } from '@angular/core';
import { ContestSettings } from '../shared/models/contest-settings.models';
import { supabase } from './supabase.client';
import { TABLE_NAMES } from './supabase.constants';
import { PostgrestSingleResponse } from '@supabase/supabase-js';
import { toApi } from '../shared/utils/case-convert';

@Injectable({
  providedIn: 'root'
})
export class SupabaseDbContestSettingsService {
  async upsertContestSettings(data: Partial<ContestSettings>): Promise<PostgrestSingleResponse<ContestSettings>> {
    const payload = {...data, singleton: true};

    return supabase
      .from(TABLE_NAMES.CONTEST_SETTINGS)
      .upsert(
        toApi(payload),
        {onConflict: 'singleton'}
      )
      .select('*')
      .single();
  }

  async fetchContestSettings(): Promise<PostgrestSingleResponse<ContestSettings>> {
    return supabase
      .from(TABLE_NAMES.CONTEST_SETTINGS)
      .select('*')
      .eq('singleton', true)
      .single();
  }
}
